import { render, staticRenderFns } from "./fulfillment-dialog-cancel-request.vue?vue&type=template&id=167c2fa6"
import script from "./fulfillment-dialog-cancel-request.vue?vue&type=script&lang=js"
export * from "./fulfillment-dialog-cancel-request.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports